<template>
  <div>
    <b-row align-v="center" class="d-flex align-items-center">
      <b-col cols="6" class="mb-2">
        <label>Tenant</label>
        <v-select
          multiple
          v-model="filterItems"
          :value="tenantFilter"
          :options="tenantOptions"
          class="w-100"
          :reduce="(val) => val.value"
          @input="(val) => $emit('update:tenantFilter', val)"
          append-to-body
          :calculate-position="withPopper"
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">
          {{ $t("alarm.alarm_type") }}
        </label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="alarmTypeFilter"
          :options="alarmTypeOptions"
          class="w-100"
          multiple
          append-to-body
          :calculate-position="withPopper"
          :reduce="(val) => val.value"
          @input="(val) => $emit('update:alarmTypeFilter', val)"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BCard, BCardHeader, BCardBody, BRow, BCol, BButton } from "bootstrap-vue";
import { String } from "lodash/_freeGlobal";
import vSelect from "vue-select";
import store from "@/store";
import popperHelper from "@/libs/popper-helper";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BButton,
    vSelect,
  },
  props: {
    tenantOptions: {
      type: Array,
      default: null,
    },
    tenantFilter: {
      type: Array | Number | String,
      default: null,
    },
    alarmTypeFilter: {
      type: Array,
      default: null,
    },
    alarmTypeOptions: {
      type: Array,
      default: null,
    },
  },
  data() {
    return { filterItems: [], datafilter: [] };
  },
  methods: {
    sendItemFilter() {
      this.datafilter = [];
      this.datafilter.push(this.filterItems);

      this.$emit("itemFilter", this.datafilter);
    },
    returnItemFilter() {
      this.getItemsFilter.forEach((element) => {
        if (this.$route.path == element.to && element.itemFilter != null) {
          this.filterItems = element.itemFilter[0];
        }
      });
    },
  },
  computed: {
    getItemsFilter() {
      return store.getters["breadcrumbNav/getItemsNav"];
    },
  },
  watch: {
    filterItems: function () {
      this.sendItemFilter();
    },
  },
  created() {
    this.returnItemFilter();
    if (this.filterItems != undefined) {
      this.$emit("update:tenantFilter", this.filterItems);
    }
  },
  setup() {
    return {
      withPopper: popperHelper.withPopper,
    };
  },
};
</script>
